import axios from 'axios'
import { host } from '../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

const dataInicial = {
    usuarios: [],
    data: {},
    prueba: false
}

//*************Types */
const OBTENER_USUARIOS_EXITO = 'OBTENER_USUARIOS_EXITO'
const OBTENER_USUARIOS_ERROR = 'OBTENER_USUARIOS_ERROR'
const AGREGAR_USUARIO_EXITO = 'AGREGAR_USUARIO_EXITO'
const AGREGAR_USUARIO_ERROR = 'AGREGAR_USUARIO_ERROR'
const RECUPERAR_CONTRASEÑA = 'RECUPERAR_CONTRASEÑA'
export const obtenerTodosLosUsuarios = createAsyncThunk(
    'OBTENER_USUARIOS_EXITO',
    async () => {
        const fullUrl = host + `AnexoUsuario/obtenerTodosLosLogin`
        const res = await axios.get(fullUrl)
        return res.data.data
    }
)

export const usuariosSlice = createSlice({
    name: 'usuarios',
    initialState: dataInicial,
    reducers: {
        setPrueba(state, {payload}){
            state.prueba = payload
        }
    },
    extraReducers: {
        [obtenerTodosLosUsuarios.fulfilled] : (state, {payload}) => {
            state.usuarios = payload
        }
    },
})

export const {setPrueba} = usuariosSlice.actions
export const usuariosReducer = usuariosSlice.reducer

// export default function usuariosReducer(state = dataInicial, action){
//     switch (action.type) {
//         case OBTENER_USUARIOS_EXITO:
//             return {...state, usuarios: action.payload}
//         case AGREGAR_USUARIO_EXITO: 
//             return {...state}
//         default:
//             return {state}
//     }
// }

//*****actions */




// export const obtenerTodosLosUsuarios = () => async(dispatch) => {
//     try {
//         const fullUrl = host + `AnexoUsuario/obtenerTodosLosLogin`
//         const res = await axios.get(fullUrl)  
//         dispatch({
//             type: OBTENER_USUARIOS_EXITO,
//             payload: res.data.data
//         })
//     } catch (error) {
//         console.log(error)
//         dispatch({
//             type: OBTENER_USUARIOS_ERROR
//         })
//     }
// }

export const registrarUsuario = (data) => async(dispatch) => {
    try {
        const fullUrl = host + `Auth/cambiarContraseña`
        const res = await axios.post(fullUrl, data)
        dispatch({
            type: AGREGAR_USUARIO_EXITO
        })
    } catch (error) {
        dispatch({
            type: AGREGAR_USUARIO_ERROR
        })
    }
}
export const CambiarContraseña = (data) => async(dispatch) => {
    try {
        const fullUrl = host + `AnexoUsuario/agregarLogin`
        const res = await axios.post(fullUrl, data)
        dispatch({
            type: RECUPERAR_CONTRASEÑA
        })
    } catch (error) {
        console.log(error)
        dispatch({
            type: AGREGAR_USUARIO_ERROR
        })
    }
}
